import React, { Suspense } from "react";
import { InfoMenu } from "./InfoMenu";
import { AdministrationUtilities } from "../../administration/AdministrationHelper";

export class Credits extends React.Component {

    constructor(props) {
        super(props);

        const installationInd = AdministrationUtilities.getInstallationId();

        this.state = {
            CustomCredits: null,
            loaded: false
        };

        this.modalRef = React.createRef();

        import(`../../_custom-layout/${installationInd}/Credits.js`)
            .then(module => {
                this.setState({
                    CustomCredits: React.lazy(() => Promise.resolve({ default: module.default })),
                    loaded: true
                });
            })
            .catch(() => {
                this.setState({
                    CustomCredits: null,
                    loaded: true
                });
            });
    }

    render() {
        const { CustomCredits, loaded } = this.state;

        if (!loaded) return null;

        return (
            <>
                {CustomCredits && (
                    <Suspense fallback={null}>
                        <CustomCredits
                            onOpenModal={(bodyName, title) => this.modalRef.current._open(bodyName, title)}
                        />
                    </Suspense>
                )}

                <InfoMenu
                    ref={this.modalRef}
                />
            </>
        );
    }
}

